import styled from "styled-components";
import {LogoContainerDefaultBox} from "./logo-container.default.box";

export const LogoContainerCasino888Box = styled(LogoContainerDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    position: relative;
    margin: 0;
    margin-bottom: 4rem;
    background: ${props => props.theme.colors.logoBackground};
    &::after {
      content: "";
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 16px;
      background-image: url(${props => props.theme.images.logoDecoration.toString()});
      background-repeat: no-repeat;
    }
  }
  
  @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
    margin-bottom: 3rem;
  }
  
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding: 0.45rem 0.5rem;
    margin-bottom: 0;
  }
`;
